export default __webpack_public_path__ + "static/media/img_elasticsearch-colorBkg.c23ba5f4.png";